module.exports = __webpack_public_path__ + "76eaa781b197b33be7a8d483c9dc19a2.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1/public/history/fi-1997.png
// module id = 349
// module chunks = 0